import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { combineReducers } from 'redux';
import { i18nIntl, parseVideo, getDaysOfTheWeeks, isNotEmpty, getRemotedbUrl, checkIfPromoHasRankingEnablable, throwErrorEvent, getStageName } from '../../lib/ep.js';
import { stage_types, stage_categories, stage_promotion_types, with_score } from '../../data/bootstrap_stages';

import ActionLink from '../builder/ActionLink';
import BuilderCanvas from '../builder/BuilderCanvas';
import BuilderSidebar from '../builder/BuilderSidebar';
import Checkbox from '../builder/Checkbox';
import DateTimePicker from '../builder/DateTimePicker';
import DesignContainerProps from '../builder/DesignContainerProps';
import DesignWarningMessage from '../builder/DesignWarningMessage';
import DisabledArea from '../builder/DisabledArea';
import { AutoPostImageUploader } from '../builder/ImageUploader';
import Input from '../builder/Input';
import MediaUploader from '../builder/MediaUploader';
import Message, { AlertMessage } from '../builder/Message';
import Model from '../builder/Model';
import { NavigationTabsBuilder } from '../builder/NavigationTabs';
import OcrSidebar from './OcrSidebar';
import RichEditor from '../builder/RichEditor';
import Select, { SelectGroup } from '../builder/Select';
import TextArea from '../builder/TextArea';
import BuilderMain from '../builder/BuilderMain.js';

import ContainerSliders from './elements/ContainerSliders';

import BracketClient from '../front/BracketClient';
import DirectParticipation from '../front/DirectParticipation';
import Layout from '../front/Layout';
import StageMosaicItem from '../front/StageMosaicItem';

import StageReqsSidebar from '../../containers/stages/StageReqsSidebar';
import StageRequirements from '../../containers/stages/StageRequirements';

import Quiz from './Quiz';
import RouletteBuilder from './RouletteBuilder';
import TriviaBuilder from './TriviaBuilder';
import CrushBuilder from './CrushBuilder';
import ScratchBuilder from './ScratchBuilder';
import MediaBuilder from './MediaBuilder';
import VotingGalleryBuilder from './VotingGalleryBuilder';
import StoryStageBuilder from './StoryStageBuilder';
import GuessWordBuilder from './GuessWordBuilder';
import CatchItBuilder from './CatchItBuilder';

import qreducer from '../../reducers/questions';

import { configureStore } from '../../store/configureStore';

import transferPlaceholder from '../../hoc/transferPlaceholder';
import BlockBuilder from '../builder/BlockView.js';
import RevealBuilder from './RevealBuilder.js';
import Tooltip from '../builder/Tooltip.js';
import StageSegmentsBuilder from './StageSegmentsBuilder.js';
import SectionTitle from '../builder/SectionTitle.js';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import BuilderSubSectionTitle from './BuilderSubSectionTitle.js';
import TeamBuilder from './TeamBuilder.js';
import CheckEnabler from '../builder/CheckEnabler.js';
import md5 from 'md5';
import ButtonCollection from '../builder/ButtonCollection.js';
import ActionButton, { SecondaryButton, SquaredButton } from '../builder/ActionButton.js';
import SmashItBuilder from './SmashItBuilder.js';
import StackItBuilder from './StackItBuilder.js';
import CrosswordsBuilder from './CrosswordsBuilder.js';
import FloatingLayer from '../builder/FloatingLayer.js';
import LinkCollection from '../ui_items/LinkCollection.js';
import PunchCardBuilder from './PunchCardBuilder.js';
import BattleBuilder from './BattleBuilder.js';
import LikeDislikeBuilder from './LikeDislikeBuilder.js';
import StageFormBuilder from './StageFormBuilder.js';
import PhotoFunBuilder from './PhotoFunBuilder.js';
import StageLoyaltyBuilder from './StageLoyaltyBuilder.js';
import StagePrizeGalleryBuilder from './StagePrizeGalleryBuilder.js';
import WordSearchBuilder from './WordSearchBuilder.js';
import MemoryBuilder from './MemoryBuilder.js';
import PuzzleBuilder from './PuzzleBuilder.js';
import MatchItBuilder from './MatchItBuilder.js';
import HiddenBuilder from './HiddenBuilder.js';
import MineSweeperBuilder from './MineSweeperBuilder.js';
import PickFavoriteBuilder from './PickFavoriteBuilder.js';
import KeyValueJson from '../builder/KeyValueJson.js';
import PenaltyBuilder from './PenaltyBuilder.js';
import CannonballBuilder from './CannonballBuilder.js';
import GuessScoreBuilder from './GuessScoreBuilder.js';
import ColorPicker from '../builder/ColorPicker.js';
import { validateOcrTicketConditions } from './OcrTicketSidebar.js';

const TextAreaPlaceHolder = injectIntl(transferPlaceholder(TextArea));
const RichPlaceHolder = injectIntl(transferPlaceholder(RichEditor));

export const qr_code_generate = (stage_id) => {
	return md5(`${stage_id}EPQR${new Date()}`).slice(0, 8);
} 

const reactivate_no_prize = (stage_id,cb) => {
	$.post(`/stages/reactivate_no_prize/${stage_id}`,(result)=>{
		if (cb != undefined)cb(result);
	},'JSON');
}

class StageEdit extends Component {
	constructor(props, context) {
		super(props, context);

		const i18n = (m, c) => i18nIntl(m, props.intl, c);

		this.state = {
			stage:props.stage?.Stage,
			errors:{},
			debug:false,
			req_reset:Math.random()*10000,
			display_stage_link_layer:false,
			enable_closed_images:false,
		};

		if(this.state.stage.layout_width == undefined) this.state.stage.layout_width = 40;
		if(this.state.stage.layout_num_cols == undefined) this.state.stage.layout_num_cols = 1;
		if(this.state.stage.layout_cols_prop == undefined) this.state.stage.layout_cols_prop = 30;

		//Ensure Fields
		if(this.state.stage.type == stage_categories.ID_ROULETTE_CATEGORY.id) {
			if(this.state.stage.roulette_slices == undefined) this.state.stage.roulette_slices = 12;
			if(this.state.stage.roulette_no_prize == undefined) this.state.stage.roulette_no_prize = 0;
		}

		//Ensure Stage Fields in Media Contest
		if(this.state.stage.type == stage_categories.ID_MEDIA_CATEGORY.id) {
			if(this.state.stage.media_size == undefined) this.state.stage.media_size = 1;
			if(this.state.stage.media_min_elements == undefined) this.state.stage.media_min_elements = 1;
			if(this.state.stage.media_max_elements == undefined) this.state.stage.media_max_elements = 2;
			if(this.state.stage.media_image == undefined) this.state.stage.media_image = true;
			if(this.state.stage.media_placeholder == undefined) this.state.stage.media_placeholder = i18n("Drop files here to upload");
			if(this.state.stage.media_title_checkbox == undefined) this.state.stage.media_title_checkbox = this.state.stage.media_title !== undefined;
		}

		this.participation_frequencies_select = [
			{ k:'hour', v:"Every hour" },
			{ k:'day', v:"Every day" },
			{ k:'week', v:"Every week" },
			{ k:'total', v:"In total" },
		];

		this.direct_type = [
			{ k:'spinner', v:"Spinner" },
			{ k:'splash', v:`${i18n("Progress bar")} (${i18n("Version", 'lowercase')} 1)` },
			{ k:'splash-2', v:`${i18n("Progress bar")} (${i18n("Version", 'lowercase')} 2)` },
			{ k:'splash-3', v:`${i18n("Progress bar")} (${i18n("Version", 'lowercase')} 3)` },
			{ k:'button', v:"By clicking on a button" },
		];

		const qstore = props.store.getState()

		var start = {
			questions: {
				questions:this.getQuestionsStage(qstore.questions.questions),
				pm:qstore.questions.pm
			}
		}

		let reducer = combineReducers({
			questions:qreducer,
		});

		this.storeQuestions = configureStore(start, reducer);
		let bts = this.props.bracketsStore.getState();
		this.storeBrackets = bts.brackets != undefined ? bts.brackets : [];
	}

	getQuestionsStage = (questions) => {
		return questions.filter(q=>{
			if (q == undefined) return false;
			return (q.Question.stage == this.props.stage.Stage.id);
		});
	}

	componentWillReceiveProps(props) {
		if(props.stage.Stage.id != this.state.stage.id) {
			this.setState({ stage:props.stage.Stage });
		}
	}

	changeMulti = (changes) => {
		for(let key in changes) {
			this.props.stage.Stage[key] = changes[key];
		}

		this.setState({stage:{...this.state.stage,...changes}})
	}

	change = (k, v, skip) => {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);
		if(k == 'start_date' && typeof(v) != 'string') v = v.format('YYYY-MM-DD HH:mm:ss');
		if(k == 'end_date' && typeof(v) != 'string') v = v.format('YYYY-MM-DD HH:mm:ss');
		
		if (k == 'direct_points' && v == '') {
			this.state.stage['points'] = "";
		}
		if (k == 'max_questions') {
			const quiz_answered_correctly = this.state.stage?.quiz_answered_correctly ?? v;
			this.state.stage['quiz_answered_correctly'] = Math.min(v,quiz_answered_correctly);
		}

		if(k == 'max_prizes_stage' && v == '0') {
			v='';
		}

		if(['guess_score_points_result','guess_score_points_outcome'].includes(k) && v == '') {
			v = '0';
		}

		if(k == 'reqs_form' && Array.isArray(v) && v.length == 0) v = null;//EMpty Array sent in Post is removed from $_POST
		if(k == 'crush_images' && Array.isArray(v) && v.length == 0) v = '';
		if(k == 'punch_images' && Array.isArray(v) && v.length == 0) v = '';
		if(k == 'main_video' && v != '') v = parseVideo(v);
		if((k == 'main_image' || k == 'direct_image') && v === null) v = ''
		if((k == 'punch_image_off' || k == 'punch_image_on') && v === null) v = ''
		if((k == 'main_image' || k == 'direct_image') && v === null) v = ''

		if (k == 'scratch') {
			v = v.map(scratch=>{
				if (scratch?.scratch_image == '') {
					delete scratch.scratch_image;
					return scratch;
				}
				return scratch;
			})
		}

		if(k == 'media_min_tags'){
			const _media_max_tags = parseInt(this.state?.stage?.['media_max_tags'] ?? 1);
			if(parseInt(v) > _media_max_tags)this.state.stage['media_max_tags'] = parseInt(v);
		}

		k = k.replace('config.layout.stage.', 'layout_');

		if(k == 'roulette_no_prize') {
			var diff = Math.max(0,parseInt(v)-parseInt(this.state.stage[k]));
			this.state.stage['roulette_slices'] = Math.min(30,parseInt(this.state.stage['roulette_slices']) + diff);
		}

		if (k == 'roulette_slices' || k =='roulette_no_prize') {
			this.state.stage['roulette_order'] = null;
		}

		if (k.indexOf('.')>-1) {

			this.setState(state=>{

				const is_full = k.indexOf('full_') == 0;
				const parts = k.split('.');
				if (is_full) {
					parts[0] = parts[0].replace('full_',"");
					parts[parts.length-1] = 'full_'+parts[parts.length-1];
				}
				let i = 0;
				let target = state.stage;
				do {
					if (target[parts[i]]== undefined) target[parts[i]] = {};
					else if (typeof target[parts[i]] == 'object') {
						target[parts[i]] = {...target[parts[i]]};
					}
					target = target[parts[i]]
					i++;
					if (i == parts.length -1) {
						target[parts[i]] = v; 
					}
	
				} while(i<parts.length-1)
				if (parts[parts.length-1] == 'replace_image' && v == null) {
					state.stage[parts[0]][parts[1]]['animation'] = 'shake';
				}

				return {...state};
			});

			
			return;

		}
		this.state.stage[k] = v;

		if(k == 'reqs_type' && v != '0') {
			this.state.stage['reqs_code_one_use'] = 1;
			this.state.stage['reqs_code_one_use_global'] = 1;
		}

		if (k == 'reqs_code_one_use' && v==0) {
			this.state.stage['reqs_code_one_use_global'] = 0;
		}

		if (k == 'reqs_code_type' && v == 0) {
			this.state.stage['reqs_code_scan'] = 0;
		}

		if(k == 'reqs_type'){
			this.state.stage['reqs_freq'] = 1;//Default requirement not "Complete other participation stages";
			if(v == '4')this.state.stage['reqs_freq'] = 0;
		}
		
		if(k == 'reqs_type' && v != '1') {
			this.state.stage['reqs_ocr_check_code'] = "";
		}
		
		if(k == 'reqs_type' && v == '5') {
			if (this.state.stage['reqs_qr_code'] == undefined && this.state.stage['reqs_qr_type'] != 'dynamic') {
				this.state.stage['reqs_qr_code'] = qr_code_generate(this.state.stage['id']);
			}
		}

		if(k == 'reqs_qr_type'){
			if(v != 'dynamic'){
				delete this.state.stage.reqs_pos;
				if(this.state.stage['reqs_qr_code'] == undefined){
					this.state.stage['reqs_qr_code'] = qr_code_generate(this.state.stage['id']);
				}
			}else{
				delete this.state.stage.reqs_qr_code;
			}
		}

		if(k == 'reqs_qr_mode' && v == 'automatic') {
			this.state.stage['display_valid_qr'] = false;
		}
		if(k == 'reqs_graphic_info' && v == '') {
			this.state.stage['reqs_premoderation'] = false;
		}

		if(k=='reqs_pos' && v == 'all')this.state.stage.reqs_pos = "";

		if(k == 'direct_splash_time') {
			this.state.stage[k] = Math.max(v, 0);
		}

		if(k == 'media_title_checkbox') {
			this.state.stage['media_title'] = (v) ? i18n("Title of the album") : "";
		}

		if(k == 'media_description_checkbox') {
			this.state.stage['media_description'] = (v) ? i18n("Description of the album") : "";
		}

		if(k == 'voting_enabled' && this.state.stage['voting_type'] == undefined){
			this.state.stage['voting_type'] = 'simple';
		}

		/*if(k == 'voting_type' && this.state.stage['voting_type'] == 'ponderated'){
			this.state.stage['voting_enable_fraud'] = false;
		}*/

		if(k == 'crush_level'){
			switch(v){
				case "5":
					this.state.stage['crush_min'] = 15;
					this.state.stage['game_time'] = 180;
				break;
				case "6":
					this.state.stage['crush_min'] = 12;
					this.state.stage['game_time'] = 120;
				break;
				case "7":
					this.state.stage['crush_min'] = 10;
					this.state.stage['game_time'] = 90;
				break;
			}
		}

		switch(k) {
			case 'reveal_num':
				switch(parseInt(v)) {
					case 1:
						this.state.stage.reveal_tries = 1;
						break;

					case 3:
						this.state.stage.reveal_tries = parseInt(this.state.stage.reveal_size) + 2;
						break;
				}
				delete this.state.stage.reveal_individual_area;
				break;
			case 'reveal_size':
				if (this.state.stage.reveal_num == 3) {
					this.state.stage.reveal_tries = parseInt(this.state.stage.reveal_size) + 2;
				}
				else {
					this.state.stage.reveal_tries = v-1;
				}
				delete this.state.stage.reveal_individual_area;
			case 'reveal_pos_mode':
				if (v == 'block') {
					this.state.stage.reveal_individual_area = "";
				}
				break;
		}

		if(skip == undefined || skip!==true) {
			this.setState({ ...this.state });
		}
	}

	debugInfo = (data) => {
		this.setState({debug:data});
	}

	reset_req = () => {
		this.setState({
			debug:false,
			req_reset:Math.random()*1000
		});
	}

	getCurrentStageType(type_id) {
		if(type_id == undefined) return null;
		return stage_types.filter(f => (f.id == type_id) ? true : false)[0];
	}

	changeAndSave = (k,v) => {
		
		this.change(k,v);
		this.saveStage();
	}

	saveStageFromLayer = (stage) => {
		this.state.stage = stage;
		this.setState({ ...this.state });
		this.saveStage();
	}

	saveStage(cb) {
		if(this.state.stage.reqs_type == "1" && (this.state.stage.reqs_code_type == "0" || this.state.stage.reqs_code_type == undefined)) {
			this.state.stage.reqs_type = "";
			this.setState({...this.state});
		}

		if(this.state.stage.reqs_type == "4" && this.state.stage.reqs_stage != undefined && this.state.stage.reqs_stage.length == 0) {
			this.state.stage.reqs_type = "";
			this.setState({...this.state});
		}

		if (this.state.stage.voting_tiers != undefined && this.state.stage.voting_tiers.length == 0) this.state.stage.voting_tiers = "";
		
		if (this.state.stage.roulette_no_prize == 0 && this.state.stage.roulette_odds != undefined &&  this.state.stage.roulette_odds[0] != undefined) {
			delete this.state.stage.roulette_odds[0];
			this.setState({...this.state});
		}

		let save = {...this.state.stage};

		if (save?.reqs_ocrticket_conditions) {
			const {valid_conditions} = validateOcrTicketConditions(save?.reqs_ocrticket_conditions);
			save.reqs_ocrticket_conditions = valid_conditions;
		}

		if (save.scratch) save.scratch = JSON.stringify(save.scratch);
		if (save.punch_images) save.punch_images = JSON.stringify(save.punch_images);
		if (save.layout_props) save.layout_props = JSON.stringify(save.layout_props);
		if (save.photo_editor_images) save.photo_editor_images = JSON.stringify(save.photo_editor_images);
		if (save.reqs_premoderation_reasons) save.reqs_premoderation_reasons = JSON.stringify(save.reqs_premoderation_reasons);
		if (save.reqs_ocrticket_conditions) save.reqs_ocrticket_conditions = JSON.stringify(save.reqs_ocrticket_conditions);
		if (save.reqs_waiting_sentences) save.reqs_waiting_sentences = JSON.stringify(save.reqs_waiting_sentences);

		if (save.media_form != undefined && save.media_form.length==0) save.media_form = "";
		if (save.loyalty_awards != undefined && save.loyalty_awards.length==0) save.loyalty_awards = "";

		if(Array.isArray(save?.crosswords_words) && save.crosswords_words.length == 0) save.crosswords_words = '';
		if(Array.isArray(save?.crosswords_positions) && save.crosswords_positions.length == 0) save.crosswords_positions = '';

		$.post('/promotions/savestage/' + this.state.stage.promotion_id, save, (res) => {
			if(cb != undefined) cb();
			if (res.stage.Stage.reqs_graphic_info == undefined) {
				delete this.state.stage.reqs_graphic_info;
				this.setState({...this.state});
			}
			EP.showSuccessSave();
		}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	}

	reactivateStage = (id) => {
		reactivate_no_prize(id,res=>{
			if (res.status != 1) return;
			this.change('no_prize_closed','');
		})
	};

	isStageWithCompletion = () => {
		const st = stage_types.find((s) => (s.id == this.state.stage.promotion_type_id));
		return st?.completion ?? false;
	};

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const section_main_path = 'stages';
		const edit_base_url = `${section_main_path}/${this.state.stage.id}/`;
		const bracket_id =  this.state.stage.bracket_id;
		const back = bracket_id != undefined ? `stages/brackets/${bracket_id}/rounds/${this.state.stage.round}` : section_main_path;
		const is_multistage = this.props?.pm?.is_multistage ?? false;
		const is_test = this.props?.pm?.test ?? false;
		const is_bracket = (this.state.stage.type == stage_categories.ID_BRACKET_CATEGORY.id) ? true : false;
		const is_voting = (this.state.stage.type == stage_categories.ID_VOTING_CATEGORY.id) ? true : false;
		let permit_segments = (this.props.pm.promo_type == '2') ? true : false;
		if(this.props.pm.login_type == '4' || this.props.pm.login_type == '3') permit_segments = false;

		const stage_with_completion = this.isStageWithCompletion();

		let sections = [
			{ label:"Go back", link:back, icon:'knk-go-prev' },
			{ label:"Options", link:`${edit_base_url}options`, icon:'knk-settings' },
		]
		if(permit_segments) {
			sections.push({ label:"***Segments", link:`${edit_base_url}segments`, icon:'knk-entries-sided' });
		}
		if(!is_voting)sections.push({ label:"Requirements", link:`${edit_base_url}requirements`, icon:'knk-brand' });

		let actual_stage_type = this.getCurrentStageType(this.state.stage.promotion_type_id);

		if(this.state.stage.type == stage_categories.ID_BRACKET_CATEGORY.id){
			actual_stage_type.name = i18n("Preview");
		}

		let stage_icon;
		switch(this.state.stage.promotion_type_id) {
			case '5':
			case '6':
			case '7':
			case '8':
				stage_icon = 'knk-to-do-list';
				break;
			default:
				stage_icon = actual_stage_type.icon_class;
				break;
		}

		sections.push({ label:actual_stage_type.name, link:`${edit_base_url}${actual_stage_type.link}`, icon:stage_icon });
		if(this.props.pm?.loyalty_enabled ?? false) {
			sections.push({ label:"Virtual coins", link:`${edit_base_url}loyalty`, icon:'knk-money' });
		}

		const is_quiz = ((this.state.stage.is_quiz != undefined && this.state.stage.is_quiz) || (this.state.stage.type == stage_categories.ID_QUIZ_CATEGORY.id || this.state.stage.type == stage_categories.ID_TIMED_CATEGORY.id || this.state.stage.type == stage_categories.ID_BRACKET_CATEGORY.id)) ? true : false;
		const display_extra_tabs = is_quiz || this.state.stage.type == stage_categories.ID_MEDIA_CATEGORY.id  || this.state.stage.type == stage_categories.ID_PHOTO_FUN.id  || this.state.stage.type == stage_categories.ID_VOTING_CATEGORY.id;
		if(display_extra_tabs) {
			sections.push({ label:"Container", link:`${section_main_path}/${this.state.stage.id}/container`, icon:'knk-page' });

			if(this.props.pm.promo_type == 2) {
				sections.push({ label:"Advanced", link:`${section_main_path}/${this.state.stage.id}/advanced`, icon:'knk-script' });
			}
		}

		const display_premoderation = false;

		const default_script_placeholder = '<script type="text/javascript">\n\tdocument.addEventListener("DOMContentLoaded", function() {\n\t\t/* '+i18n("Your code goes here")+'... */\n\t});\n</script>';

		let has_results_in_stage_bracket = false;
		if(is_bracket && !is_test) {
			const not_bye_candidates = this.storeBrackets.candidates.filter(p => p.BracketCandidate.bracket_id == bracket_id && p.BracketCandidate.status == 1);
			let matches_with_real_candidates = [];
			const matches = this.storeBrackets.matches != undefined ? this.storeBrackets.matches.filter((m)=> {
					return m.BracketMatch.bracket_id == bracket_id && m.BracketMatch.stage_id==this.state.stage.id
				}) : [];

			matches.map((match) => {
				let candidate_A = not_bye_candidates.filter((cA) =>  { return match.BracketMatch.candidateA.id == cA.BracketCandidate.id;});
				let candidate_B = not_bye_candidates.filter((cB) =>  { return match.BracketMatch.candidateB.id == cB.BracketCandidate.id;});
				if(candidate_A.length>0 && candidate_B.length>0){
					matches_with_real_candidates.push(match);
				}
			});

			const confirmed_matches = matches_with_real_candidates.length > 0 ? matches_with_real_candidates.filter((obj)=>{ return obj.BracketMatch.status == "1"}) : [];
			has_results_in_stage_bracket = (confirmed_matches.length > 0) ? true : false;
		}
		let start_date_out_of_range = false;
		let end_date_out_of_range = false;

		if(is_multistage || is_bracket) {
			start_date_out_of_range = (EPDateBefore(this.state.stage.start_date, this.props.pm.start_date) || EPDateAfter(this.state.stage.start_date, this.props.pm.end_date)) ? true : false;
			end_date_out_of_range = (EPDateBefore(this.state.stage.end_date, this.props.pm.start_date) || EPDateAfter(this.state.stage.end_date, this.props.pm.end_date)) ? true : false;
		}

		const stages_mosaic_layout = this.props.pm?.stages_mosaic_layout ?? 'mosaic';
		const is_stages_mosaic = (stages_mosaic_layout == 'mosaic') ? true : false;

		let stage_proportion = this.props.pm?.stages_mosaic_image_proportion ?? 'landscape';
		let stage_image_sizes = false;

		if(stages_mosaic_layout == 'mosaic') {
			switch(stage_proportion) {
				case 'squared':
					stage_image_sizes = { width:500, height:500 };
					break;

				case 'portrait':
					stage_image_sizes = { width:480, height:720 };
					break;

				case 'landscape':
				default:
					stage_image_sizes = { width:800, height:420 };
					break;
			}
		} else if((this.props.pm?.stages_mosaic_list_graphic_display ?? 'icon') == 'image') {
			stage_proportion = 'squared';
			stage_image_sizes = { width:150, height:150 };
		}

		let questions = this.props.store.getState().questions;
		let points_per_hit_in_bracket = this.state.stage.points_per_question!=undefined ? this.state.stage.points_per_question : 1;

		let label_blocked_option_when_stage_is_close = i18n("You can't edit this because the voting of this matchup is over and you have already confirmed the result in the brackets editor.");

		let has_any_extra_stage_image = false;
		if(isNotEmpty(this.state.stage, 'full_stage_picture_closed_participations')) has_any_extra_stage_image = true;
		if(isNotEmpty(this.state.stage, 'full_stage_picture_closed_date')) has_any_extra_stage_image = true;
		if(isNotEmpty(this.state.stage, 'full_stage_picture_completed')) has_any_extra_stage_image = true;

		let errors = {};
		let hide_dates_and_score = false;
		if(is_bracket) {
			const this_bracket = this.storeBrackets.brackets.find(m => m.Bracket.id==bracket_id);
			const actual_round = this_bracket.Bracket.current_round;
			const num_rounds = this_bracket.Bracket.num_rounds;
			const bracket_ended = actual_round>num_rounds;
			let configured_automatic_round = (this_bracket.Bracket.automatic == "1" && this_bracket.Bracket['end_round_'+actual_round] && this_bracket.Bracket['start_round_'+actual_round]) ? true : false;
			hide_dates_and_score = configured_automatic_round || (actual_round > this.state.stage.round && !has_results_in_stage_bracket);
			if(!has_results_in_stage_bracket && configured_automatic_round) {
				//label_blocked_option_when_stage_is_close = i18n("You can't edit it because this voting page is actually configured with automatic system.");
				//has_results_in_stage_bracket = true;
			}

			if(!bracket_ended && (this_bracket.Bracket.automatic == "1" || this_bracket.Bracket.automatic == true) && (!this_bracket.Bracket['end_round_'+actual_round] || !this_bracket.Bracket['start_round_'+actual_round])){
				errors['automatic'] = label_blocked_option_when_stage_is_close = i18n("In order to activate the automatic mode, you must insert the start and end dates for each round. Please, review the schedule of the automatic mode.");
				has_results_in_stage_bracket = true;
			}
		}

		const video_url = (this.state.stage.main_video) ? this.state.stage.main_video.url : null;

		let placeholder_stage = '';
		const stage_type = stage_types.find((f) => (f.id == this.state.stage.promotion_type_id));
		if(stage_type)placeholder_stage = i18n(stage_type.name);
		const simple_voting = is_voting && this.state.stage.voting_type != 'simple'

		const stages = this.props.stagesStore.getState().stages.stages;
		let stages_pos = [];
		const stage_sections = this.props.pm?.stage_sections ?? [];
		stages.sort((a, b) => {
			if (a.Stage.section_id !== b.Stage.section_id) {
				const section_a = a?.Stage?.section_id ?? 0;
				const section_b = b?.Stage?.section_id ?? 0;

				let pos_a = 0;
				let pos_b = 0;
				for (var i in stage_sections) {
					if (stage_sections[i].id == section_a) {
						pos_a = i;
					}
					if (stage_sections[i].id == section_b) {
						pos_b = i;
					}
				}
			  return pos_a - pos_b;
			} else {
				const pos_a = a?.Stage?.pos ?? "1";
				const pos_b = b?.Stage?.pos ?? "1";
			  return pos_a.localeCompare(pos_b);
			}
		  }).map((st,i) => {
			stages_pos[st.Stage.id] = i+1; 
		})
		let total_stages = 0;
		let stages_list = [{label:'',items:[{k:'',v:`-- ${i18n("No stage")} --`}]}];

		stage_sections.map((section) => {
			const stages_in_section = stages.filter((st) => ( st.Stage.section_id==section.id && st.Stage.promotion_type_id != stage_promotion_types.MEDIA_AUTOCONTENT.id ));
			let _items = [];
			stages_in_section.map((stage) =>{
				total_stages++;
				let label = `${stages_pos[stage.Stage.id]} - ${getStageName(stage.Stage, i18n)}`;
				let mirror_stage = stages.find((s) => (s.Stage.id == stage.Stage.next_stage_id));
				label +=  mirror_stage != null && isNotEmpty(stage.Stage,'next_stage_id') ? ` (${i18n("From")} #${stages_pos[mirror_stage.Stage.id]})` : ` (${i18n("Root")})`; 
				_items.push({k:stage.Stage.id,v:label,disabled:stage.Stage.id == this.state.stage.id});
			});
			stages_list.push({
				label:section.title,
				items:_items,
			});
		})

		//No section Stage

		const stages_without_section = stages.filter((st) => (!isNotEmpty(st.Stage,'section_id') && st.Stage.promotion_type_id != stage_promotion_types.MEDIA_AUTOCONTENT.id));
		if(stages_without_section.length>0){
			const empty_section = {label:i18n("Without section"),items:[]};
			stages_without_section.map((stage) => {
				total_stages++;
				empty_section.items.push({
					k:stage.Stage.id,
					v:`${stages_pos[stage.Stage.id]} - ${getStageName(stage.Stage, i18n)}`,
					disabled:stage.Stage.id == this.state.stage.id,
				});
			});
			stages_list.push(empty_section);
		}

		let domain = window.public_url;
		if(this.props.promoModel?.Accountdomain?.domain ?? false) {
			domain = `https://${this.props.promoModel.Accountdomain.domain}/`;
		}

		const link_to_participate_stage = `${domain}promotions/participate/${this.props.pm.id}/${this.state.stage.id}`;
		const stage_indicator = <ButtonCollection>
			<ActionButton
				disabled={true}
				autotranslate={false}
			>{getStageName(this.state.stage, i18n)}</ActionButton>

			<SquaredButton
				icon='knk-links'
				onClick={() => this.setState({ display_stage_link_layer:true })}
				aria-label="View links"
			/>

			{(this.state.display_stage_link_layer) && (
				<FloatingLayer backButton={() => this.setState({ display_stage_link_layer:false })}>
					<div>
						<SectionTitle>Stage direct link</SectionTitle>

						<SectionSubtitle>You can share this url to send users directly to this participation stage.</SectionSubtitle>

						<SectionSubtitle>They'll be required to login before they can participate.</SectionSubtitle>

						<LinkCollection
							items={[{
								label: {
									children:"Direct link to this participation stage",
								},
								urls: [{
									url:getRemotedbUrl(link_to_participate_stage, null, false),
								}],
							}]}
						/>

						<ButtonCollection in_floating={true}>
							<SecondaryButton
								onClick={() => this.setState({ display_stage_link_layer:false })}
							>Close</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</ButtonCollection>;

		const tokens = this.props.loyaltyTokensStore.getState();
		const loyalty_token = (tokens.tokens.tokens.length > 0) ? tokens.tokens.tokens[0] : null;

		return (
			<Switch>
				<Route path={'/' + section_main_path + '/:id/roulette'}>
					<RouletteBuilder
						section_main_path={edit_base_url}
						winnerStore={this.props.winnerStore}
						instantStore={this.props.instantStore}
						prizes={this.props.prizes}
						promotion={this.props.pm}
						promoModel={this.props.promoModel}
						stage={this.state.stage}
						change={this.change}
						in_stages={true}
						on_save={(cb) => this.saveStage(cb)}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/puzzle'}>
					<PuzzleBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/wordsearch'}>
					<WordSearchBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/memory'}>
					<MemoryBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/matchit'}>
					<MatchItBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/hidden'}>
					<HiddenBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/minesweeper'}>
					<MineSweeperBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/(questions|design|gameplay|gamesettings|gamesuccess|quiz_advanced|testreact|summary|results|questions_container|quizstats)'}>
					<Quiz
						basename={section_main_path + '/' + this.state.stage.id}
						stage_id={this.state.stage.id}
						stage={this.state.stage}
						changeStage={this.change}
						saveStage={this.saveStage.bind(this)}
						pm={this.props.pm}
						promoModel={this.props.promoModel}
						store={this.props.store}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/(trivia)'}>
					<Provider store={this.storeQuestions}>
						<TriviaBuilder
							basename={section_main_path + '/' + this.state.stage.id}
							stage_id={this.state.stage.id}
							stage={this.state.stage}
							changeStage={this.change}
							changeMulti={this.changeMulti}
							saveStage={this.saveStage.bind(this)}
							promoModel={this.props.promoModel}
							questionStore={this.props.store}
							available_languages={this.props.available_languages}
							stage_indicator={stage_indicator}
						/>
					</Provider>
				</Route>

				<Route path={'/' + section_main_path + '/:id/crush'}>
					<CrushBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={this.props.promoModel}
						stage_indicator={stage_indicator}
						//promoModel={pm}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/guessword'}>
					<GuessWordBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/falling'}>
					<CatchItBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/scratch'}>
					<ScratchBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						instantStore={this.props.instantStore}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={this.props.promoModel}
						//promoModel={pm}
						prizes={this.props.prizes}
						on_save={(cb) => this.saveStage(cb)}
						winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/taptap'}>
					<SmashItBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						instantStore={this.props.instantStore}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						on_save={(cb) => this.saveStage(cb)}
						winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/tower'}>
					<StackItBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						instantStore={this.props.instantStore}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						on_save={(cb) => this.saveStage(cb)}
						winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/crosswords'}>
					<CrosswordsBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						instantStore={this.props.instantStore}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						on_save={(cb) => this.saveStage(cb)}
						winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/stamps'}>
					<PunchCardBuilder
						// stages={this.props.stages}
						// is_multistage={is_multistage}
						// isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						// instantStore={this.props.instantStore}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						// on_save={(cb) => this.saveStage(cb)}
						// winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/form'}>
					<StageFormBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						//prizes={this.props.prizes}
						on_save={(cb) => this.saveStage(cb)}
						//winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/(photofun|scenes)'}>
					<PhotoFunBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promoModel={pm}
						on_save={(cb) => this.saveStage(cb)}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/penalty'}>
					<PenaltyBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/cannonball'}>
					<CannonballBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
						type='cannonball'
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/basketball'}>
					<CannonballBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						questionStore={this.props.store} //To migrate from questions
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
						type='basketball'
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/score_predictor'}>
					<GuessScoreBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promoChangeSave={this.props.promoChangeSave}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
						type='score_predictor'
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/bracket_predictor'}>
					<GuessScoreBuilder
						stage={this.state.stage}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promoChangeSave={this.props.promoChangeSave}
						promotion={this.props.pm}
						is_bracket={true}
						promoModel={pm}
						prizes={this.props.prizes}
						stage_indicator={stage_indicator}
						type='bracket_predictor'
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/prize'}>
					<Provider store={this.props.loyaltyTokensStore} >
						<StagePrizeGalleryBuilder
							stages={this.props.stages}
							is_multistage={is_multistage}
							isCorporate={this.props.isCorporate}
							stage={this.state.stage}
							change={this.change}
							changeMulti={this.changeMulti}
							saveStage={this.saveStage.bind(this)}
							promotion={this.props.pm}
							promoModel={pm}
							prizes={this.props.prizes}
							on_save={(cb) => this.saveStage(cb)}
							stage_indicator={stage_indicator}
							//loyaltyTokensStore={this.props.loyaltyTokensStore}
							//winnerStore = {this.props.winnerStore}
						/>
					</Provider>
				</Route>

				<Route path={'/' + section_main_path + '/:id/pick_favorite'}>
					<PickFavoriteBuilder
						// stages={this.props.stages}
						// is_multistage={is_multistage}
						// isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						// instantStore={this.props.instantStore}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						// on_save={(cb) => this.saveStage(cb)}
						// winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/battle'}>
					<BattleBuilder
						// stages={this.props.stages}
						// is_multistage={is_multistage}
						// isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						// instantStore={this.props.instantStore}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						// on_save={(cb) => this.saveStage(cb)}
						// winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/likedislike'}>
					<LikeDislikeBuilder
						// stages={this.props.stages}
						// is_multistage={is_multistage}
						// isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						// instantStore={this.props.instantStore}
						change={this.change}
						changeMulti={this.changeMulti}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						// on_save={(cb) => this.saveStage(cb)}
						// winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/(reveal|images|design_reveal|test|instructions)'}>
					<RevealBuilder
						stages={this.props.stages}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						instantStore={this.props.instantStore}
						change={this.change}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						on_save={(cb) => this.saveStage(cb)}
						winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/(team)'}>
					<TeamBuilder
						stages={this.props.stages}
						questions={(questions.questions).filter((obj) => {if(obj == undefined) return false; return obj.Question.stage == this.state.stage.id;})}
						is_multistage={is_multistage}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						instantStore={this.props.instantStore}
						change={this.change}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						prizes={this.props.prizes}
						on_save={(cb) => this.saveStage(cb)}
						winnerStore = {this.props.winnerStore}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/(media|candidates)'}>
					<MediaBuilder
						stages={stages}
						isCorporate={this.props.isCorporate}
						stage={this.state.stage}
						nav_sections={sections}
						nav_active={this.props.route.location.pathname}
						stage_id={this.state.stage.id}
						change={this.change}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						stage_indicator={stage_indicator}
					/>
				</Route>

				{(permit_segments) && (
					<Route path={`/${section_main_path}/:id/segments`}>
						<StageSegmentsBuilder
							nav_sections={sections}
							nav_active={this.props.route.location.pathname}
							stage={this.state.stage}
							promotion={this.props.pm}
							pm={this.props.promoModel}
							errors={errors}
							change={this.change}
							saveStage={this.saveStage.bind(this)}
							stage_indicator={stage_indicator}
						/>
					</Route>
				)}

				<Route path={`/${section_main_path}/:id/loyalty`}>
					<Provider store={this.props.loyaltyTokensStore}>
						<StageLoyaltyBuilder
							nav_sections={sections}
							nav_active={this.props.route.location.pathname}
							stage={this.state.stage}
							promotion={this.props.pm}
							pm={this.props.promoModel}
							errors={errors}
							change={this.change}
							loyaltyTokensStore={this.props.loyaltyTokensStore}
							saveStage={this.saveStage.bind(this)}
							stage_indicator={stage_indicator}
						/>
					</Provider>
				</Route>

				<Route path={'/' + section_main_path + '/:id/view'}>
					<BlockBuilder />
				</Route>

				<Route path={'/' + section_main_path + '/:id/gallery'}>
					<VotingGalleryBuilder
						stages={this.props.stages}
						stage={this.props.stage.Stage}
						nav_sections={sections}
						nav_active={this.props.route.location.pathname}
						stage_id={this.state.stage.id}
						change={this.change}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/story'}>
					<StoryStageBuilder
						stage={this.props.stage.Stage}
						nav_sections={sections}
						nav_active={this.props.route.location.pathname}
						stage_id={this.state.stage.id}
						change={this.change}
						saveStage={this.saveStage.bind(this)}
						promotion={this.props.pm}
						promoModel={pm}
						stage_indicator={stage_indicator}
					/>
				</Route>

				<Route path={'/' + section_main_path + '/:id/ocr'}>
					<BuilderMain pm={this.props.promoModel}>
						<BuilderSidebar onSave={(cb) => this.saveStage(cb)} errors={errors}>
							<NavigationTabsBuilder
								active={this.props.route.location.pathname}
								sections={[{ label:"Go back", link:`${section_main_path}/${this.state.stage.id}/requirements`, icon:'knk-go-prev' }]}
							>{stage_indicator}</NavigationTabsBuilder>

							<OcrSidebar
								promotion={this.props.pm}
								stage={this.state.stage}
								change={this.change}
								debug={this.state.debug}
								reset_req={this.reset_req}
								saveStage={this.saveStage.bind(this)}
							/>
						</BuilderSidebar>

						<BuilderCanvas fit_to_window="content">
							<Layout promo={pm.attributes} menus={pm.Custom__Menus} is_builder={true} page="landing" stages={this.props.stages} >
								<StageRequirements
									key={'requirements'+this.state.req_reset}
									stage={this.state.stage}
									is_builder={true}
									debugInfo={this.debugInfo}
									promotion={this.props.pm}
								/>
							</Layout>
						</BuilderCanvas>
					</BuilderMain>
				</Route>

				<Route path={'/' + section_main_path + '/:id'}>
					<BuilderMain pm={this.props.promoModel}>
						<BuilderSidebar onSave={(cb) => this.saveStage(cb)} errors={errors}>
							<NavigationTabsBuilder
								sections={sections}
								active={this.props.route.location.pathname}
							>{stage_indicator}</NavigationTabsBuilder>

							<Switch>
								<Route path={'/' + section_main_path + '/:id/container'}>
									<ContainerSliders
										section="stage"
										layout={this.state.stage}
										change={this.change}
									/>
								</Route>

								<Route path={'/' + section_main_path + '/:id/advanced'}>
									<Model model={this.state.stage} change={this.change}>
										<TextAreaPlaceHolder
											name="code_tracking_stage"
											_class={{v_size:'huge', first:true}}
											placeholder={default_script_placeholder}
											zoomable={true}
											is_monospaced={true}
											label_props={{
												tooltip:<Tooltip>In this field you can insert HTML, Javascript or any other code that can be read by a web browser.</Tooltip>,
											}}
										>Javascript, HTML and your own code</TextAreaPlaceHolder>
									</Model>
								</Route>

								<Route exact={true} path={'/' + section_main_path + '/:id/options'}>
									<div>
										{(is_multistage || is_bracket) && (
											<article>
												{(is_test && is_bracket) && (
													<AlertMessage
														title="Promotion in test mode"
														_class={{ other:'in_top' }}
													>
														<p>{i18n("This voting page and the set-up will be deleted when you disable Test Mode. You can set it up again when you generate the round in the active promotion.")}</p>
													</AlertMessage>

												)}

												<BuilderSubSectionTitle
													title="Main settings"
													icon='knk-settings'
													_class={(is_test && is_bracket) ? ' gui_not_in_top_huge' : ''}
												/>

												<Model model={this.state.stage} change={this.change}>
													<Input
														name="display_title"
														placeholder={placeholder_stage}
														max_length={40}
													>Stage name</Input>

													<TextArea
														name="display_description"
														max_length={250}
														label_props={{
															tooltip:<Tooltip>(Optional) Use this field to display longer messages about this stage in the layout.</Tooltip>,
														}}
													>Stage description</TextArea>
												</Model>

												{(!hide_dates_and_score) && (
													<DisabledArea disabled={has_results_in_stage_bracket} message={label_blocked_option_when_stage_is_close} tooltip_position="bottom">
														<Model classname="gui_equal_columns gui_padded_children_low keep_in_responsive" model={this.state.stage} change={this.change}>
															<DateTimePicker
																value={this.state.stage.start_date}
																name="start_date"
																standalone={true}
																time_interval={1}
																max_date={this.state.stage.end_date}
															>Start date</DateTimePicker>

															<DateTimePicker
																value={this.state.stage.end_date}
																name="end_date"
																standalone={true}
																time_interval={1}
																min_date={this.state.stage.start_date}
															>End date</DateTimePicker>
														</Model>
													</DisabledArea>
												)}

												{((start_date_out_of_range || end_date_out_of_range) && !is_test) && (
													<AlertMessage
														title="Out of promotion publication dates"
													>
														<p>{i18n("Stage dates must be within the promotion's publication period.")}</p>
														<p>{i18n("Review them or change the publication dates.")}</p>
														<p><ActionLink _href="#dates">See publication dates</ActionLink></p>
													</AlertMessage>
												)}

												{(stage_image_sizes !== false) && (
													<article class="gui_not_in_top_huge">
														<BuilderSubSectionTitle
															title="Stage images"
															icon='knk-picture'
														/>
														
														<Model model={this.state.stage} change={this.change}>
															<AutoPostImageUploader
																small_input={true}
																auto_url={`/promotions/auto_img/${this.state.stage.promotion_id}`}
																auto_type='stages'
																image={this.state.stage?.full_stage_picture ?? null}
																name="stage_picture"
																//_accepted_formats={["PNG", "GIF", "JPG"]}
																_size={stage_image_sizes}
																autotranslate={false}
															>Main image</AutoPostImageUploader>
														</Model>
														
														{(!this.state.enable_closed_images && has_any_extra_stage_image === false) && (
															<p>
																<ActionLink 
																	onClick={() => this.setState({ enable_closed_images:true })}
																>Update the stage images based on their status</ActionLink>
															</p>
														)}

														{(this.state.enable_closed_images || has_any_extra_stage_image !== false) && (
															<Model model={this.state.stage} change={this.change}>
																<AutoPostImageUploader
																	small_input={true}
																	auto_url={`/promotions/auto_img/${this.state.stage.promotion_id}`}
																	auto_type='stages'
																	image={this.state.stage?.full_stage_picture_closed_participations ?? null}
																	name="stage_picture_closed_participations"
																	_size={stage_image_sizes}
																	autotranslate={false}
																>{i18n("Stage closed")} - {i18n("No more participations")}</AutoPostImageUploader>

																<AutoPostImageUploader
																	small_input={true}
																	auto_url={`/promotions/auto_img/${this.state.stage.promotion_id}`}
																	auto_type='stages'
																	image={this.state.stage?.full_stage_picture_closed_date ?? null}
																	name="stage_picture_closed_date"
																	_size={stage_image_sizes}
																	autotranslate={false}
																>{i18n("Stage closed")} - {i18n("By date")}</AutoPostImageUploader>

																<AutoPostImageUploader
																	small_input={true}
																	auto_url={`/promotions/auto_img/${this.state.stage.promotion_id}`}
																	auto_type='stages'
																	image={this.state.stage?.full_stage_picture_completed ?? null}
																	name="stage_picture_completed"
																	_size={stage_image_sizes}
																	autotranslate={false}
																>{i18n("Stage closed")} - {i18n("By completion")}</AutoPostImageUploader>
															</Model>
														)}
													</article>
												)}
											</article>
										)}

										{(!is_bracket) ? (
											<article class={(is_multistage) ? "gui_not_in_top_huge" : null}>
												<BuilderSubSectionTitle
													title="Frequency of participation"
													icon='knk-timecounter'
												/>

												<DisabledArea disabled={(simple_voting) ? true : false} message="This value cannot be modified for stages of the voting type">
													<Model model={this.state.stage} change={this.change}>
														<Input
															_class={{size:20}}
															name="max_participations"
															disabled={simple_voting}
															value={(simple_voting) ? 1 : (this.state.stage?.max_participations ?? 1)}
															_type="number"
															min={1}
															max={(simple_voting) ? 1 : 9999999999999}
														>How many times can a user participate?</Input>
													</Model>
												</DisabledArea>

												<Model model={this.state.stage} change={this.change}>
													<Select
														_class={{size:50}}
														name="participation_frequency"
														after_message={is_voting ? "Change this field to allow users to repeat their votes daily or hourly." : null}
														values={this.participation_frequencies_select}
													>How often?</Select>

													{(this.state.stage.participation_frequency != "total") && (
														<Input
															_class={{size:20}}
															name="total_participations"
															_type="number"
															min={0}
															max={9999999999999}
														>Total number of participations per user</Input>
													)}

													{(this.state.stage.participation_frequency == 'week') && (
														<Select
															_class={{size:50}}
															name="week_start"
															values={getDaysOfTheWeeks(parseInt(window?.week_start ?? '1'))}
															label_props={{
																tooltip:<Tooltip>Users will be able to participate again from this weekday at 00:00h of the promotion time zone</Tooltip>,
															}}
														>First day of the week</Select>
													)}
												</Model>
											</article>
										) : (
											(!hide_dates_and_score) && (
												<article class={"gui_not_in_top_huge"}>
													<BuilderSubSectionTitle
														title="Score"
														icon='knk-goal'
													/>

													<DisabledArea disabled={has_results_in_stage_bracket} message={label_blocked_option_when_stage_is_close} tooltip_position="bottom">
														<Model model={this.state.stage} change={this.change}>
															<Input
																name="points_per_question"
																_type="number"
																min={1}
																max={10000}
																value={points_per_hit_in_bracket}
															>Points for correct answer</Input>
														</Model>
													</DisabledArea>
												</article>
											)
										)}

										{(!is_bracket) && (
											<article class="gui_not_in_top_huge">
												<BuilderSubSectionTitle
													title="Other"
													icon='knk-timecounter'
												/>

												<Model model={this.state.stage} change={this.change}>
													

													{this.state.state?.one_prize_only != undefined && (
														<Checkbox
															name="one_prize_only"
															label_props={{
																tooltip:<Tooltip>Do not let users participate again if they've already won a prize.</Tooltip>,
															}}
														>Participants can only win a single direct prize</Checkbox>
													)}

													<CheckEnabler 
														label="Limit the number of direct prizes a user can win"
														label_props={{
															tooltip:<Tooltip>Do not allow further participation if a user wins a certain number of prizes.</Tooltip>,
														}}
														enabled={this.state.stage?.max_prizes_stage != undefined}
														onDisable={() => {
															this.change('max_prizes_stage',"");
														}}
													>
														<Input 
															name="max_prizes_stage" 
															model={this.state.stage} 
															change={this.change}
															_class={{size:30}}
														>Limit of direct prizes per user</Input>
													</CheckEnabler>

													<Checkbox
														name="should_close_no_prize"
														label_props={{
															tooltip:<Tooltip autotranslate={false}>{`${i18n("Applies only to direct assignation prizes: registration prizes, probability prizes or instant moment prizes.")}<br /><br />${i18n("In case of a multi-stage promotion, only applies to direct prizes linked to this specific stage.")}`}</Tooltip>,
														}}
													>Automatically close the stage when all its direct prizes are exhausted</Checkbox>

													{(stage_with_completion) && (
														<Checkbox
															name="close_on_completion"
															label_props={{
																tooltip:<Tooltip>The stage will be closed for the user once completed</Tooltip>,
															}}
														>Prevent users from participating more than once after completing the stage</Checkbox>
													)}

													<Checkbox
														name="show_number_participants"
														label_props={{
															tooltip:<Tooltip>The number will appear in the public list of participation stages. You can change the label that appears using the dictionaries feature.</Tooltip>,
														}}
													>Show the total of participations of the stage</Checkbox>

													{(with_score(this.props.pm.promotion_type_id) && checkIfPromoHasRankingEnablable(this.props.pm)) && (
														<Checkbox 
															value={(this.state?.stage?.public_answers ?? true)} 
															name="public_answers"
														>Show user answers in ranking</Checkbox>
													)}

													{((window?.features ?? []).includes('linked_stages') && total_stages>1) && (
														<SelectGroup 
															name="next_stage_id" 
															_class={{size:70}} 
															values={stages_list}
															autotranslate_options={false}
														>Next stage</SelectGroup>
													)}

													{/* we hide this option temporally */}
													{(false) && (
														<CheckEnabler
															name="meta"
															label="Add metadata to the stage"
															/*label_props={{
																tooltip:<Tooltip>Do not allow further participation if a user wins a certain number of prizes.</Tooltip>,
															}}*/
															enabled={this.state.stage?.meta != undefined || this.state.stage?.full_meta}
															onDisable={() => {
																this.change('meta',"");
																this.change('full_meta',"");
															}}
														>
															<article class="gui_not_in_top">
																<KeyValueJson
																	name="meta"
																	full_json={this.state.stage?.full_meta}
																	json={this.state.stage?.meta ?? {}}
																	ul_classes='gui_overflowable'
																	change={this.change.bind(this)}
																/>
															</article>
														</CheckEnabler>
													)}

												
												</Model>
											</article>
										)}

										{(display_premoderation) && (
											<article class="gui_not_in_top_huge">
												<BuilderSubSectionTitle
													title="Pre-moderation"
													icon='knk-toc'
												/>

												<Model model={this.state.stage} change={this.changeStage.bind(this)}>
													<Checkbox
														name="confirm_to_publish"
														label_props={{
															tooltip:<Tooltip>Select this field if you wish to revise and confirm each entry before it is published.</Tooltip>,
														}}
													>Enable premoderation</Checkbox>

													<Input
														name="mail_on_entry"
														placeholder="mail@domain.com"
														label_props={{
															tooltip:<Tooltip>Enter a valid email address to receive an email when a new entrant registers in this promotion. You can specify multiple email addresses separated by comma. Notifications are sent every 30 minutes and gather all the new entrants registered during this period. Leave the field empty if you don't want to receive notifications. This option can be disabled at any time.</Tooltip>,
														}}
													>Notification of new entry</Input>
												</Model>
											</article>
										)}
									</div>
								</Route>

								<Route exact={true} path={'/' + section_main_path + '/:id/requirements'} render={(route) => {
									return (
										<StageReqsSidebar
											default_path={`${section_main_path}/${route.match.params.id}`}
											state={this.state.stage}
											winnerStore={this.props.winnerStore}
											codesets={this.props.codesets}
											change={this.change}
											promotion={pm.attributes}
											domain={pm?.Accountdomain ?? null}
											stages={this.props.stages}
											saveStage={(stage) => this.saveStageFromLayer(stage)}
											validationSitesStore={this.props.validationSitesStore}
											isCorporate={this.props.isCorporate}
											loyaltyTokensStore={this.props.loyaltyTokensStore}
											//validationSites={this.props.validationSites}
										/>
									)
								}} />

								<Route exact={true} path={'/' + section_main_path + '/:id/brackets'} render={(route) => {
									const bracket_id = route.match.params.id;
									let all_candidates_with_image = true;
									this.storeBrackets.candidates.filter(p => p.BracketCandidate.bracket_id == bracket_id).map((candidate) => {
										if(candidate.BracketCandidate != undefined && candidate.BracketCandidate.full_image == undefined)all_candidates_with_image = false;
									});

									return (
										<article>
											<BuilderSubSectionTitle
												title="Display options"
												icon='knk-awesome-editor'
											/>

											<DisabledArea disabled={has_results_in_stage_bracket} message={label_blocked_option_when_stage_is_close} tooltip_position="bottom">
												<Model model={this.state.stage} change={this.change}>
													<Checkbox
														name="show_bracket"
													>Show bracket with matchup position</Checkbox>

													<Input
														name="matchup_message"
														placeholder="Pick your favorite"
													>Message</Input>

													{(all_candidates_with_image) && (
														<Checkbox
															name="hide_candidate_info"
														>Only show candidate images</Checkbox>
													)}
												</Model>
											</DisabledArea>
										</article>
									)
								}} />

								<Route exact={true} path={'/' + section_main_path + '/:id/direct'}>
									<div>
										<Message
											_class={{ other:'in_top' }}
										>
											<p>{i18n("Check-in is a transition screen before registering the user participation. You can personalize the content of the screen with an image or gif and a text. The user does not interact with any element.")}</p>
										</Message>

										<Model model={this.state.stage} change={this.change}>
											<MediaUploader
												imageField="direct_image"
												videoField="main_video"
												image={this.state.stage.full_direct_image}
												video={video_url}
											>Upload media</MediaUploader>

											<RichPlaceHolder
												name="direct_description"
												placeholder="Registering the participation..."
												label_props={{
													tooltip:<Tooltip>Enter a blank space to delete the text</Tooltip>,
												}}
											>Description</RichPlaceHolder>

											<Select
												name="direct_type"
												values={this.direct_type}
											>How do you want the transition to be?</Select>

											{(!['button'].includes(this.state.stage.direct_type)) && (
												<ColorPicker
													name="direct_color"
													_class={{ size:50 }}
													_hide_code={true}
													color={this.state.stage?.direct_color ?? (this.props.pm?.layout_props?.color?.main_color ?? `rgba(30, 34, 170, 1)`)}
												>Transition color</ColorPicker>
											)}

											{(this.state.stage.direct_type == 'button') && (
												<Input
													name="direct_btn_text"
													placeholder="Enter"
												>Button Text</Input>
											)}

											<Checkbox
												name="direct_points"
											>Give points when completing this participation stage</Checkbox>

											{(this.state.stage.direct_points != undefined) && (
												<Input
													name="points"
													placeholder="0"
													_class={{size:50}}
												>How many points?</Input>
											)}

											{(this.state.stage.direct_type == undefined || this.state.stage.direct_type != 'button') && (
												<Message
													icon='knk-information'
													_class={{ other:'not_awesome centered_message in_bottom' }}
													autotranslate={false}
													custom_title_content={true}
													title={(this.state.stage.direct_splash_time == undefined || this.state.stage.direct_splash_time > 0) ? <FormattedMessage id="In production, the page will be automatically redirected after {num} seconds" values={{num:Math.max(((this.state.stage.direct_splash_time != undefined) ? this.state.stage.direct_splash_time : 3), 0)}} /> : i18n("In production, the page will be automatically redirected immediately")}
												/>
											)}

											<Message
												_class={{ other:'in_bottom' }}
											>
												<p><FormattedMessage id="If you give direct prizes for the fact of registering a participation remember to configure them from the {link_prizes} menu." values={{link_prizes:<ActionLink _href="#prizes">Prizes</ActionLink>}} /></p>
											</Message>
										</Model>
									</div>
								</Route>
							</Switch>
						</BuilderSidebar>

						<Switch>
							<Route path={'/'+section_main_path+'/:id/container'}>
								<DesignContainerProps
									promo={this.props.pm}
									stage={this.state.stage}
									page="stage"
								/>
							</Route>

							<Route path={'/'+section_main_path+'/:id/advanced'}>
								<DesignWarningMessage
									promotion={this.state.pm}
								/>
							</Route>

							<Route path={'/'+section_main_path+'/:id/brackets'}>
								<BuilderCanvas is_adaptable={true} fit_to_window="content">
									<Layout promo={pm.attributes} menus={pm.Custom__Menus} is_builder={true} page="landing" without_context={false}>
										<BracketClient
											is_game={false}
											is_builder={true}
											is_test={false}
											stage={this.state.stage}
											questions={(questions.questions).filter((obj) => {if(obj == undefined) return false; return obj.Question.stage == this.state.stage.id;})}
											gp_hash={null}
											promotion={pm.attributes}
											submitQuiz={null}
											canPlayAgain={null}
											multiparticipation={false}
											brackets={this.storeBrackets}
										/>
									</Layout>
								</BuilderCanvas>
							</Route>

							<Route path={'/'+section_main_path+'/:id/options'}>
								{(!is_multistage && !is_bracket) ? (
									<BuilderCanvas
										not_awesome={true}
										//add_public_css_vars={false}
										fit_to_window="content"
										not_bordered={true}
										off_content={(this.state.stage.no_prize_closed != undefined && this.state.stage.no_prize_closed) ? (
											<AlertMessage
												title="This stage is closed because all of its prizes have been used up"
												_class={{ other:'in_top in_bottom' }}
											>
												<p><FormattedMessage id="If you want to reopen it, first add new prize units, and then {link}." values={{ link:<ActionLink onClick={() => this.reactivateStage(this.state.stage.id)}>reactivate it here</ActionLink>}} /></p>
											</AlertMessage>) : null}
									>
										<p><strong>{i18n("Participation frequency")}</strong></p>

										<p>{i18n("Set the number of times a user can participate and how often.")}</p>
									</BuilderCanvas>
								) : (
									<BuilderCanvas
										//not_awesome={true}
										//add_public_css_vars={false}
										fit_to_window="content"
										off_content={(this.state.stage.no_prize_closed != undefined && this.state.stage.no_prize_closed) ? (
											<AlertMessage
												title="This stage is closed because all of its prizes have been used up"
												_class={{ other:'in_top in_bottom' }}
											>
												<p><FormattedMessage id="If you want to reopen it, first add new prize units, and then {link}." values={{ link:<ActionLink onClick={() => this.reactivateStage(this.state.stage.id)}>reactivate it here</ActionLink>}} /></p>
											</AlertMessage>) : null}
									>
										<Layout promo={pm.attributes} menus={pm.Custom__Menus} is_builder={true} page="landing" display_header={false} display_footer={false}>
											<div class={'gui_multiparticipation_landing col_double in_top do_not_adapt num_col_1 is_' + stage_proportion + ' is_' + ((this.props.pm.stages_mosaic_layout != undefined) ? this.props.pm.stages_mosaic_layout : 'mosaic')}>
												<StageMosaicItem
													stage={this.state.stage}
													promo={this.props.pm}
													is_builder={true}
													force_view={true}
												/>
											</div>
										</Layout>
									</BuilderCanvas>
								)}
							</Route>

							<Route path={'/'+section_main_path+'/:id/requirements'}>
								{(this.state.stage.reqs_type != undefined && this.state.stage.reqs_type != '') ? (
									<BuilderCanvas fit_to_window="content">
										<Layout promo={pm.attributes} menus={pm.Custom__Menus} is_builder={true} page="landing">
											<StageRequirements
												intl={this.props.intl}
												stage={this.state.stage}
												is_builder={true}
												stages={this.props.stages}
												promotion={this.props.pm}
												loyalty={{
													totals: loyalty_token ? {
														[loyalty_token.LoyaltyToken.id]:0
													} : {},
													tokens:loyalty_token ? {
														[loyalty_token.LoyaltyToken.id]:loyalty_token
													} : {}}
												}
											/>
										</Layout>
									</BuilderCanvas>
								) : (
									<BuilderCanvas is_adaptable={false} add_public_css_vars={false}>
										<div class="not_awesome gui_is_padded">
											<SectionTitle _class={{icon:'knk-brand', first:true}}>Requirements</SectionTitle>
											<SectionSubtitle>A requirement is an action that the user needs to carry out in order to be able to complete their participation.</SectionSubtitle>
											<SectionSubtitle>This action is carried out on the screen before the participation.</SectionSubtitle>

											<div class="gui_flexbox gui_not_in_top gui_padded_children sweet_explanation">
												<div class="col">
													<strong class="title">{i18n("The available requirements are")}:</strong>

													<ul class="bulleted_list gui_margined_children_v">
														<li><u>{i18n("Validate code")}:</u> {i18n("The user should enter a valid code to participate.")}</li>

														<li><u>{i18n("Watch a video")}:</u> {i18n("The user should watch a YouTube video until the end to participate.")}</li>

														<li><u>{i18n("Purchase receipt (manual validation)")}:</u> {i18n("The users have to upload a picture of a receipt to participate. The receipt can be automatically validated through OCR in White Label version.")}</li>
													</ul>
												</div>
											</div>
										</div>
									</BuilderCanvas>
								)}
							</Route>

							<Route exact={true} path={'/' + section_main_path + '/:id/direct'}>
								<BuilderCanvas fit_to_window="content">
									<Layout promo={pm.attributes} menus={pm.Custom__Menus} is_builder={true} page="form">
										<DirectParticipation
											stage={{Stage:this.state.stage}}
											promotion={{ Promotion:pm.attributes }}
											is_builder={true}
										/>
									</Layout>
								</BuilderCanvas>
							</Route>
						</Switch>
					</BuilderMain>
				</Route>
			</Switch>
		)
	}
}

export default injectIntl(StageEdit);